/**
 * 비밀번호 초기화 확인 모달.
 * Figma「09 비밀번호 초기화 확인」(node 12679:4833) — RDS Dialog.
 */
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import {
  popupPrimaryButtonClassName,
  popupSecondaryButtonClassName,
} from '@/shared/components/ui/popup-styles';
import { Info } from 'lucide-react';
import React from 'react';

export type PasswordResetConfirmModalProps = {
  open: boolean;
  email: string;
  name: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const PasswordResetConfirmModal: React.FC<
  PasswordResetConfirmModalProps
> = ({ open, email, name, onClose, onConfirm }) => (
  <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
    <DialogContent showCloseButton={false} className="max-w-[480px]">
      <DialogHeader>
        <DialogTitle>비밀번호를 초기화하시겠습니까?</DialogTitle>
        <DialogDescription className="space-y-3 text-left">
          <span className="block">
            {email} ({name}) 계정의 비밀번호가 초기화됩니다.
          </span>
          <span className="block space-y-1">
            <span className="block">
              · 새 임시 비밀번호가 발급되며, 화면에 1회만 표시됩니다.
            </span>
            <span className="block">
              · 해당 계정의 기존 로그인 세션이 모두 만료됩니다.
            </span>
            <span className="block">
              · 대상 계정은 최초 로그인 시 비밀번호를 변경해야 합니다.
            </span>
          </span>
        </DialogDescription>
      </DialogHeader>

      <div className="flex items-start gap-2 rounded-12 bg-ruda-warning-50 px-3.5 py-2.5 text-sm text-ruda-warning">
        <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        <p className="min-w-0 flex-1">
          초기화 수행 내역은 감사 로그에 기록됩니다. 비밀번호 값은 기록되지
          않습니다.
        </p>
      </div>

      <DialogFooter>
        <Button
          type="button"
          className={popupSecondaryButtonClassName}
          onClick={onClose}
        >
          취소
        </Button>
        <Button
          type="button"
          className={popupPrimaryButtonClassName}
          onClick={onConfirm}
        >
          초기화
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
